import http from '../../http'

const createFeature = payload => http.post(`features`, payload)
const getFeatures = ({ page, pageAll = false }, currentQuery) => http.get(`features?page=${page}&pageAll=${pageAll}${currentQuery ?? ''}`)
const getFeature = id => http.get(`features/${id}`)
const updateFeature = (id, payload) => http.patch(`features/${id}`, payload)

export {
  createFeature,
  getFeatures,
  getFeature,
  updateFeature
}